import { createFileRoute } from "@tanstack/react-router";

import { PageChangeHistory } from "~/components/admin/page-change-history";
import { pageChangesQueryOptions } from "~/lib/functions/organization-pages";

export const Route = createFileRoute("/admin/cih/page-changes")({
  staticData: { title: "Page changes" },
  // The list's opening filters, so the first paint has the rows.
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      pageChangesQueryOptions({ changedBy: "all", days: 90 }),
    ),
  component: PageChangesPage,
});

function PageChangesPage(): React.JSX.Element {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6">
          <h1 className="mb-1 text-2xl font-medium text-gray-900">
            Page changes
          </h1>
          <p className="text-sm text-gray-500">
            Every change sent, published, returned or discarded on organization
            and program pages. Use it to decide which fields representatives
            keep editing.
          </p>
        </div>
        <PageChangeHistory />
      </div>
    </div>
  );
}
